import React from 'react';
import {
  House,
  ShieldCheck,
  Bed,
  ForkKnife,
  PawPrint,
  Heart,
} from '@phosphor-icons/react';
import ServicePage from './ServicePage';

const facilities = [
  { icon: House, label: 'Private cottages', sub: 'Quiet, climate-controlled rooms' },
  { icon: Bed, label: 'Dedicated bedding', sub: 'Soft, sanitised for every stay' },
  { icon: ShieldCheck, label: '24/7 supervision', sub: 'Trained handlers on rotation' },
  { icon: ForkKnife, label: 'Scheduled meals', sub: 'Diet-aware feeding routine' },
  { icon: PawPrint, label: 'Outdoor play', sub: 'Open grounds and shaded zones' },
  { icon: Heart, label: 'Calm routine', sub: 'Rest, play and quiet time balanced' },
];

const gallery = [
  {
    url: 'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?auto=format&fit=crop&w=1200&q=80',
    title: 'Cottage interiors',
    description: 'Soft bedding, fresh air and a quiet corner of their own.',
  },
  {
    url: 'https://images.unsplash.com/photo-1583511655826-05700d52f4d9?auto=format&fit=crop&w=1200&q=80',
    title: 'Outdoor stretches',
    description: 'Shaded walkways and open grounds to roam between rests.',
  },
  {
    url: 'https://images.pexels.com/photos/4587959/pexels-photo-4587959.jpeg?auto=compress&cs=tinysrgb&w=1200',
    title: 'Mealtime',
    description: 'Portioned, scheduled meals tailored to each guest.',
  },
];

const highlights = [
  'Spaces designed for natural ventilation and sunlight',
  'Separate quiet zones for senior and shy dogs',
  'Pet-first wayfinding across the campus',
  'On-call vet support for the duration of every stay',
];

const DogBoarding = () => (
  <ServicePage
    eyebrow="Dog Boarding"
    title="A home away from home"
    lede="Premium overnight stays with attentive care, calm spaces and a routine that feels familiar."
    heroImage="https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=2000&q=80"
    heroAlt="Dog resting at boarding facility"
    intro="Our boarding campus is built around comfort — quiet cottages, well-ventilated indoor kennels and open grounds for daily stretches. Every stay follows a consistent rhythm of meals, play, rest and supervised social time."
    facilities={facilities}
    gallery={gallery}
    highlights={highlights}
    closingTitle="Stay, play, feel at home"
    closingBody="Whether it's a single night or an extended stay, your dog settles into a thoughtful routine the moment they arrive."
  />
);

export default DogBoarding;
